// src/components/auth/AuthLayout.tsx
import React from "react";

export default function AuthLayout({
  children,
  maxWidth = "780px",
}: {
  children: React.ReactNode;
  maxWidth?: string;
}) {
  return (
    <div
      className="wrapper"
      style={{
        minHeight: "100vh",
        background: "#f6f8fb",
      }}
    >
      <section
        className="login-content"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px 16px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth,
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            boxShadow: "0 20px 45px rgba(15, 23, 42, 0.08)",
            padding: "34px",
          }}
        >
          <div className="text-center">
            <img
              src="asset/images/logo.png"
              alt="AIADI"
              className="img-fluid small-logo"
              style={{
                maxWidth: "170px",
                maxHeight: "110px",
                marginBottom: "24px",
              }}
            />
          </div>

          <div style={{ width: "100%" }}>{children}</div>
        </div>
      </section>
    </div>
  );
}
